import { useCallback } from 'react'

interface Options {

  /** 回调授权页原有的返回处理。 */
  onBack: () => void

  /** 回调授权页确认协议后继续既有提交链路。 */
  onConfirmAgreement: () => void

  /** 回调授权页保留的协议跳转动作。 */
  onOpenAgreement: (agreementKey: string) => void

  /** 回调授权页保留的第三方产品授权请求与结果分流。 */
  onSubmit: () => void

  /** 回调授权页已有协议勾选状态切换。 */
  onToggleAgreement: () => void

  /** 回调授权页已有第三方产品选择状态切换。 */
  onToggleProduct: (productId: string) => void
}

export interface V2AuthorizeBusinessBridge {

  /** 用户返回时委托旧容器。 */
  onBack: () => void

  /** 用户确认协议弹窗时委托旧容器。 */
  onConfirmAgreement: () => void

  /** 用户打开协议时委托旧容器。 */
  onOpenAgreement: (agreementKey: string) => void

  /** 用户提交时委托旧容器。 */
  onSubmit: () => void

  /** 用户切换协议时委托旧容器。 */
  onToggleAgreement: () => void

  /** 用户切换产品时委托旧容器。 */
  onToggleProduct: (productId: string) => void
}

/**
 * useV2AuthorizeBusinessBridge — 连接匹配回调授权页既有业务与 v2 展示皮肤。
 * Hook 只整理回调注入，不读取或改变 API、Storage、埋点、路由、倒计时及原有结果分流。
 * @returns {V2AuthorizeBusinessBridge} 供 v2 授权皮肤调用的旧业务动作接口
 */
const useV2AuthorizeBusinessBridge = ({
  onBack,
  onConfirmAgreement,
  onOpenAgreement,
  onSubmit,
  onToggleAgreement,
  onToggleProduct,
}: Options): V2AuthorizeBusinessBridge => ({
  onBack: useCallback(() => onBack(), [onBack]),
  onConfirmAgreement: useCallback(() => onConfirmAgreement(), [onConfirmAgreement]),
  onOpenAgreement: useCallback((agreementKey: string) => onOpenAgreement(agreementKey), [onOpenAgreement]),
  onSubmit: useCallback(() => onSubmit(), [onSubmit]),
  onToggleAgreement: useCallback(() => onToggleAgreement(), [onToggleAgreement]),
  onToggleProduct: useCallback((productId: string) => onToggleProduct(productId), [onToggleProduct]),
})

export default useV2AuthorizeBusinessBridge
